import I18N from '@leverege/i18n';
import DataViewerModelUpdaterCreator from "../DataViewerModelUpdaterCreator.js";
import AggregationsView from "./AggregationsView.js";
import AggsListModel from "./shared/AggsListModel.js";
const {
  tf,
  tfIcon
} = I18N.ns('molten.dataViewers.aggregations.AggregationsDataViewer');
export default {
  id: 'molten.dataViewers.aggregations.AggregationsDataViewer',
  type: 'molten.Aggregations',
  name: tf('aggregationsViewer'),
  icon: tfIcon('configIcon', 'fa fa-wrench fa-fw'),
  location: ['aux', 'card'],
  matches: {
    type: 'GroupDataViewer'
  },
  settingsUpdaters: DataViewerModelUpdaterCreator.create('AggregationsListModelUpdater'),
  createSettings: () => {
    return AggsListModel.create();
  },
  component: AggregationsView
};